import { LoadState } from '@/lib/helpers';
import { FormikErrors, FormikValues } from 'formik';
import { FocusEvent, ForwardedRef, ReactNode } from 'react';

export type FormInputSize = 'x-small' | 'small' | 'medium';

export const getMuiSize = (size: FormInputSize): 'small' | 'medium' => {
  if (['small', 'x-small'].includes(size)) {
    return 'small';
  }

  return 'medium';
};

export interface FormProps {
  name: string;
  label?: ReactNode;
  disabled?: boolean;
  autoFocus?: boolean;
  error?: string;
  errors?: FormikErrors<FormikValues>;
  fullWidth?: boolean;
  required?: boolean;
  readonly?: boolean;
  onBlur?: (value: string, event: FocusEvent<HTMLInputElement>) => void;
  size?: FormInputSize;
  ref?: ForwardedRef<HTMLInputElement>;
  loadState?: LoadState;
  emptyMessage?: string;
  withNotSet?: boolean;
}
